(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8552,4012,5467,4006],{

/***/ 2067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _src_components_Shared_BreadCrumbs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5467);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1555);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1608);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6896);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4012);
/* harmony import */ var _styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6279);
/* harmony import */ var _styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _src_components_handlers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9400);
/* harmony import */ var _src_components_Shared_Next_seo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6543);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var SystemsPage = function SystemsPage(_ref) {
  var _aboutData$items, _aboutData$features, _seoData$title, _seoData$title2, _seoData$description, _seoData$keywords, _aboutData$items2;

  var aboutData = _ref.aboutData,
      seoData = _ref.seoData;

  var _useIntl = (0,react_intl__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(),
      locale = _useIntl.locale,
      formatMessage = _useIntl.formatMessage;

  aboutData === null || aboutData === void 0 ? void 0 : (_aboutData$items = aboutData.items) === null || _aboutData$items === void 0 ? void 0 : _aboutData$items.sort(function (a) {
    return (a === null || a === void 0 ? void 0 : a.slug) == "brief" ? -1 : 1;
  });
  var renderFeatures = aboutData === null || aboutData === void 0 ? void 0 : (_aboutData$features = aboutData.features) === null || _aboutData$features === void 0 ? void 0 : _aboutData$features.map(function (f, k) {
    var _f$title, _f$description;

    return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      xs: "12",
      md: "8",
      lg: "6",
      xl: "4",
      className: "text-center",
      key: "about" + k
    }, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
      className: "feature",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: "img-wrap-div",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "img-wrap",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
            src: (0,_src_components_handlers__WEBPACK_IMPORTED_MODULE_4__/* .handleImage */ .M)(f === null || f === void 0 ? void 0 : f.image),
            width: "45",
            height: "47",
            alt: "feature"
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: "title",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
          className: "unique-bold",
          children: f === null || f === void 0 ? void 0 : (_f$title = f.title) === null || _f$title === void 0 ? void 0 : _f$title[locale]
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: "p",
        dangerouslySetInnerHTML: {
          __html: f === null || f === void 0 ? void 0 : (_f$description = f.description) === null || _f$description === void 0 ? void 0 : _f$description[locale]
        }
      })]
    }));
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
    children: [(seoData === null || seoData === void 0 ? void 0 : (_seoData$title = seoData.title) === null || _seoData$title === void 0 ? void 0 : _seoData$title[locale]) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_src_components_Shared_Next_seo__WEBPACK_IMPORTED_MODULE_5__["default"], {
      title: seoData === null || seoData === void 0 ? void 0 : (_seoData$title2 = seoData.title) === null || _seoData$title2 === void 0 ? void 0 : _seoData$title2[locale],
      description: seoData === null || seoData === void 0 ? void 0 : (_seoData$description = seoData.description) === null || _seoData$description === void 0 ? void 0 : _seoData$description[locale],
      keywords: seoData === null || seoData === void 0 ? void 0 : (_seoData$keywords = seoData.keywords) === null || _seoData$keywords === void 0 ? void 0 : _seoData$keywords[locale]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_src_components_Shared_BreadCrumbs__WEBPACK_IMPORTED_MODULE_2__["default"], {
      heading: formatMessage({
        id: "about"
      }),
      description: "".concat(formatMessage({
        id: "main"
      }), " / ").concat(formatMessage({
        id: "about"
      })),
      background: aboutData === null || aboutData === void 0 ? void 0 : aboutData.breadCurmbImage
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
      className: "wrapper ".concat((_styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().aboutPage)),
      children: [aboutData === null || aboutData === void 0 ? void 0 : (_aboutData$items2 = aboutData.items) === null || _aboutData$items2 === void 0 ? void 0 : _aboutData$items2.map(function (item, index) {
        var _item$heading, _item$description;

        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
          className: "details-row w-100 mb-5",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "w-auto ",
            style: _objectSpread({}, index % 2 ? {
              order: "-1",
              marginInline: "0 auto"
            } : {
              order: "1",
              marginInline: "auto 0 "
            }),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
              src: (0,_src_components_handlers__WEBPACK_IMPORTED_MODULE_4__/* .handleImage */ .M)(item === null || item === void 0 ? void 0 : item.image),
              width: "494",
              height: "500",
              alt: "about-image"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            xl: "6",
            md: "12",
            className: "align-self-center ",
            children: [index == 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
              className: "section-tag text-start",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                id: "about"
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("h2", {
              className: "unique-bold d-inline-flex align-items-center",
              children: item === null || item === void 0 ? void 0 : (_item$heading = item.heading) === null || _item$heading === void 0 ? void 0 : _item$heading[locale]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              className: "text-start dangerous-html",
              dangerouslySetInnerHTML: {
                __html: item === null || item === void 0 ? void 0 : (_item$description = item.description) === null || _item$description === void 0 ? void 0 : _item$description[locale]
              }
            })]
          })]
        }, index);
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: "row features",
        children: renderFeatures
      })]
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (SystemsPage);

/***/ }),

/***/ 5467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(682);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6896);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);







var BreadCrumb = function BreadCrumb(_ref) {
  var _heading$locale, _description$locale;

  var heading = _ref.heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "" : _ref$description;

  var _useIntl = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(),
      locale = _useIntl.locale;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(),
      pathname = _useRouter.pathname;

  var shouldHidePath = pathname.startsWith("/blogs/") && pathname !== "/blogs";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: "breads wrapper",
    style: {
      backgroundColor: "rgb(112 96 166 / 100%)"
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "inner",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h1", {
          className: "unique-bold h3",
          children: (_heading$locale = heading === null || heading === void 0 ? void 0 : heading[locale]) !== null && _heading$locale !== void 0 ? _heading$locale : heading
        }), ((description === null || description === void 0 ? void 0 : description[locale]) || (description === null || description === void 0 ? void 0 : description.length) > 0) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ul", {
          children: !shouldHidePath && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
            children: (_description$locale = description === null || description === void 0 ? void 0 : description[locale]) !== null && _description$locale !== void 0 ? _description$locale : description
          })
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (BreadCrumb);

/***/ }),

/***/ 6543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _src_components_helpers_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(540);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);





var Seo = function Seo(_ref) {
  var title = _ref.title,
      description = _ref.description,
      keywords = _ref.keywords,
      _ref$noindex = _ref.noindex,
      noindex = _ref$noindex === void 0 ? false : _ref$noindex;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(),
      asPath = _useRouter.asPath,
      locale = _useRouter.locale;

  var _buildSeoAlternates = (0,_src_components_helpers_seo__WEBPACK_IMPORTED_MODULE_3__/* .buildSeoAlternates */ .Rl)(asPath, locale),
      canonical = _buildSeoAlternates.canonical,
      languageAlternates = _buildSeoAlternates.languageAlternates;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_0__/* .NextSeo */ .PB, {
    title: title,
    description: description,
    defaultTitle: title,
    noindex: noindex,
    nofollow: noindex,
    canonical: canonical,
    languageAlternates: languageAlternates,
    additionalMetaTags: [{
      name: "keywords",
      content: keywords
    }]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Seo);

/***/ }),

/***/ 9400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ handleImage; }
});

;// CONCATENATED MODULE: ./src/assets/images/placeholder.jpg
/* harmony default export */ var placeholder = ({"src":"/_next/static/media/placeholder.75cf2fc2.jpg","height":319,"width":474,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAUACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABwEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAAsgP/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/9oACAEBAAE/AH//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAECAQE/AH//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAEDAQE/AH//2Q==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/components/handlers/index.js

var handleImage = function handleImage(image) {
  var _ref;

  if ((_ref = "".concat(image)) !== null && _ref !== void 0 && _ref.includes("http")) return image;

  if (image) {
    if (!image.startsWith("/")) image = "/".concat(image);
    return "".concat("https://alnojoom.ejjadh.info/").concat(image);
  }

  return image || (placeholder === null || placeholder === void 0 ? void 0 : placeholder.src);
};

/***/ }),

/***/ 540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rl": function() { return /* binding */ buildSeoAlternates; }
/* harmony export */ });
/* unused harmony exports SITE_URL, DEFAULT_LOCALE, localizedUrl */
// ====== إعدادات الـ SEO المشتركة ======
var SITE_URL = "https://alnjoom.sa";
var DEFAULT_LOCALE = "ar"; // النسخة الافتراضية (x-default) هي العربية
// ينظّف الـ path: يشيل الـ query/hash ويضبط الـ trailing slash

var normalizePath = function normalizePath() {
  var asPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var path = String(asPath).split("?")[0].split("#")[0] || "/";
  if (!path.startsWith("/")) path = "/".concat(path); // مطابقة لإعداد trailingSlash: true في next.config.js

  if (path !== "/" && !path.endsWith("/")) path = "".concat(path, "/");
  return path;
}; // يبني رابط مطلق للّغة المطلوبة (العربية بدون بادئة، الإنجليزية ببادئة /en)


var localizedUrl = function localizedUrl(asPath, locale) {
  var path = normalizePath(asPath); // يبدأ بـ "/" وينتهي بـ "/"

  if (locale === DEFAULT_LOCALE) return "".concat(SITE_URL).concat(path);
  return path === "/" ? "".concat(SITE_URL, "/").concat(locale, "/") : "".concat(SITE_URL, "/").concat(locale).concat(path);
}; // يبني canonical + hreflang (ar / en / x-default) لأي صفحة
// x-default يشير دائمًا للنسخة العربية

var buildSeoAlternates = function buildSeoAlternates(asPath) {
  var currentLocale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_LOCALE;
  return {
    canonical: localizedUrl(asPath, currentLocale),
    languageAlternates: [{
      hrefLang: "ar",
      href: localizedUrl(asPath, "ar")
    }, {
      hrefLang: "en",
      href: localizedUrl(asPath, "en")
    }, {
      hrefLang: "x-default",
      href: localizedUrl(asPath, DEFAULT_LOCALE)
    }]
  };
};

/***/ }),

/***/ 2879:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us",
      function () {
        return __webpack_require__(2067);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6279:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"aboutPage":"about_aboutPage___uNeg","gradient_in":"about_gradient_in__4ZHig","gradient_out":"about_gradient_out__GyvQ6","gradient_opacity_out":"about_gradient_opacity_out__gUj2k","gradient_opacity_in":"about_gradient_opacity_in__tlwUy"};

/***/ }),

/***/ 1555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useCol */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





function useCol({
  as,
  bsPrefix,
  className,
  ...props
}) {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'col');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapBreakpoints */ .pi)();
  const minBreakpoint = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapMinBreakpoint */ .zG)();
  const spans = [];
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let span;
    let offset;
    let order;
    if (typeof propValue === 'object' && propValue != null) {
      ({
        span,
        offset,
        order
      } = propValue);
    } else {
      span = propValue;
    }
    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
    if (order != null) classes.push(`order${infix}-${order}`);
    if (offset != null) classes.push(`offset${infix}-${offset}`);
  });
  return [{
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, ...spans, ...classes)
  }, {
    as,
    bsPrefix,
    spans
  }];
}
const Col = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref) => {
  const [{
    className,
    ...colProps
  }, {
    as: Component = 'div',
    bsPrefix,
    spans
  }] = useCol(props);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ...colProps,
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, !spans.length && bsPrefix)
  });
});
Col.displayName = 'Col';
/* harmony default export */ __webpack_exports__["Z"] = (Col);

/***/ }),

/***/ 682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





const Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  fluid = false,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'container');
  const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, fluid ? `${prefix}${suffix}` : prefix)
  });
});
Container.displayName = 'Container';
/* harmony default export */ __webpack_exports__["Z"] = (Container);

/***/ }),

/***/ 1608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





const Row = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const decoratedBsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'row');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapBreakpoints */ .pi)();
  const minBreakpoint = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapMinBreakpoint */ .zG)();
  const sizePrefix = `${decoratedBsPrefix}-cols`;
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let cols;
    if (propValue != null && typeof propValue === 'object') {
      ({
        cols
      } = propValue);
    } else {
      cols = propValue;
    }
    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, decoratedBsPrefix, ...classes)
  });
});
Row.displayName = 'Row';
/* harmony default export */ __webpack_exports__["Z"] = (Row);

/***/ }),

/***/ 4012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(680);
/* harmony import */ var _useIntl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6896);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */




function areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(prevProps, ["values"]);
    var nextValues = nextProps.values, nextOtherProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(nextProps, ["values"]);
    return ((0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .wU)(nextValues, values) &&
        (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .wU)(otherProps, nextOtherProps));
}
function FormattedMessage(props) {
    var intl = (0,_useIntl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? react__WEBPACK_IMPORTED_MODULE_0__.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag,
    });
    if (typeof children === 'function') {
        return children(Array.isArray(nodes) ? nodes : [nodes]);
    }
    if (Component) {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(nodes));
    }
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, nodes);
}
FormattedMessage.displayName = 'FormattedMessage';
var MemoizedFormattedMessage = react__WEBPACK_IMPORTED_MODULE_0__.memo(FormattedMessage, areEqual);
MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
/* harmony default export */ __webpack_exports__["Z"] = (MemoizedFormattedMessage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,2143,9774,2888,179], function() { return __webpack_exec__(2879); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);